import * as React from 'react';
import styled, {css} from "styled-components";
import {transition} from "helpers/css";

interface TabBarProps {
  active: TabBarItem['num'];
  items: TabBarItem[];
  onChange: (tab: number) => void;
  children: React.ReactNode | React.ReactNodeArray;
}

export interface TabBarItem {
  label: string;
  num: number;
}

const Container = styled.div`
`;

const Tabs = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: -8px;
  margin-left: -8px;
`;

const Content = styled.div`
  margin-top: 20px;
`;

const Tab = styled.div<{active?: boolean}>`
  width: max-content;
  height: max-content;
  font-size: 15px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.01em;

  padding: 14px 22px;
  border-radius: 100px;
  
  background-color: ${({active}) => active && '#3264EF'};
  color: ${({active}) => active && '#ffffff'};
  border: 
      1px 
      solid
      ${({active}) => active ? 'transparent' : '#E6E6E8'};
  
  margin-bottom: 8px;
  margin-left: 8px;
  
  ${transition()};
  
  cursor: pointer;
  
  &:hover {
    ${({active}) => !active && css`
      border-color: transparent;
      background-color: white;
    `}
  }
`

/**
 * render landing page tab bar
 * @constructor
 */
export default function TabBar(props: TabBarProps): React.ReactElement {

  function changeHandler(tab: number) {
    props.onChange(tab)
  }

  function renderTab(tab: TabBarItem) {
    const isActive = props.active === tab.num;
    return (
      <Tab
        key={tab.num+tab.label}
        active={isActive}
        onClick={() => changeHandler(tab.num)}
      >
        {tab.label}
      </Tab>
    )
  }

  return (
    <Container>
      <Tabs>
        {props.items.map(renderTab)}
      </Tabs>
      <Content>
        {props.children}
      </Content>
    </Container>
  );
}
